// extracted by mini-css-extract-plugin
export var centerText = "_ej-8";
export var container = "_ej-0";
export var doughnutContainer = "_ej-7";
export var legend = "_ej-a";
export var legendItemColorDisplay = "_ej-b";
export var legendItemLabel = "_ej-d";
export var legendItemValue = "_ej-c";
export var lg = "_ej-5";
export var maxWidth = "_ej-9";
export var md = "_ej-4";
export var responsive = "_ej-6";
export var sm = "_ej-3";
export var xs = "_ej-2";
export var xxs = "_ej-1";